define('vspot-angular/services/job-service',[], function () {
    'use strict';

    return ['resources.Job', function (Job) {

        return {

            /**
             * query:
             * Retrieve data on a single job.
             * @param {int} id - id of job to display
             * @param {int} activityId - id of activity the job is on (for auth)
             * @param {str} accessKey - access key for the activity (for auth)
             * @param {bool} includeComments - this indicates how much of the comments data to return
             *      - if false, then we just return the latest comment for this job.
             *        otherwise, we return every comment for this job.
             * @param {bool} includeJobAssignments - this indicates how much of the jobassignment data to return.
             */
            get: function(id, activityId, accessKey, includeComments, includeJobAssignments) {
                return Job.get({
                    id:                     id,
                    activity_id:            activityId,
                    selected_activity:      activityId,
                    accesskey:              accessKey,
                    include_comments:       includeComments,
                    include_jobassignments: includeJobAssignments
                });
            }
        };
    }];
});

